import { ActivityV1Type } from "../../../types";

export type MainInfoSectionId =
  | "basic"
  | "content"
  | "cover"
  | "standalone"
  | "publication"
  | "mobile"
  | "limits"
  | "versioning"
  | "agenda";

export type MainInfoContentVariant =
  | "package"
  | "url-res"
  | "brightcove"
  | "youtube"
  | "linkedin"
  | "lti"
  | "survey"
  | "class";

export interface MainInfoConfig {
  sections: MainInfoSectionId[];
  contentVariant: MainInfoContentVariant;
  durationRequired: boolean;
  requiredFields: string[];
}

const COMMON_REQUIRED = ["title", "description", "cover_id"];

export const MAIN_INFO_BY_TYPE: Record<ActivityV1Type, MainInfoConfig> = {
  DA_XAPI: {
    sections: [
      "basic",
      "content",
      "cover",
      "standalone",
      "publication",
      "mobile",
      "limits",
      "versioning",
    ],
    contentVariant: "package",
    durationRequired: true,
    requiredFields: [...COMMON_REQUIRED, "duration", "xapi_package_id"],
  },
  DA_SCORM: {
    sections: [
      "basic",
      "content",
      "cover",
      "standalone",
      "publication",
      "mobile",
      "limits",
      "versioning",
    ],
    contentVariant: "package",
    durationRequired: true,
    requiredFields: [...COMMON_REQUIRED, "duration", "scorm_package_id"],
  },
  DA_EXTERNAL_RES: {
    sections: [
      "basic",
      "content",
      "cover",
      "standalone",
      "publication",
      "mobile",
      "limits",
    ],
    contentVariant: "brightcove",
    durationRequired: true,
    requiredFields: [...COMMON_REQUIRED, "duration", "external_file_url"],
  },
  DA_URL_RES: {
    sections: [
      "basic",
      "content",
      "cover",
      "standalone",
      "publication",
      "mobile",
      "limits",
    ],
    contentVariant: "url-res",
    durationRequired: true,
    requiredFields: [...COMMON_REQUIRED, "duration", "external_file_url"],
  },
  DA_YOUTUBE: {
    sections: [
      "basic",
      "content",
      "cover",
      "standalone",
      "publication",
      "mobile",
      "limits",
    ],
    contentVariant: "youtube",
    durationRequired: true,
    requiredFields: [...COMMON_REQUIRED, "duration", "youtube_video"],
  },
  DA_LINKEDIN: {
    sections: [
      "basic",
      "content",
      "cover",
      "standalone",
      "publication",
      "mobile",
      "limits",
    ],
    contentVariant: "linkedin",
    durationRequired: true,
    requiredFields: [...COMMON_REQUIRED, "duration", "external_id"],
  },
  DA_LTI: {
    sections: [
      "basic",
      "content",
      "cover",
      "standalone",
      "publication",
      "mobile",
      "limits",
    ],
    contentVariant: "lti",
    durationRequired: false,
    requiredFields: [...COMMON_REQUIRED, "external_id", "lti_account_id"],
  },
  DA_SURVEY: {
    sections: [
      "basic",
      "content",
      "cover",
      "standalone",
      "publication",
      "mobile",
      "limits",
    ],
    contentVariant: "survey",
    durationRequired: true,
    requiredFields: [...COMMON_REQUIRED, "duration", "survey_id"],
  },
  DA_PHYSICAL_CLASS: {
    sections: [
      "basic",
      "content",
      "cover",
      "standalone",
      "publication",
      "limits",
      "agenda",
    ],
    contentVariant: "class",

    durationRequired: true,

    requiredFields: [
      ...COMMON_REQUIRED,
      "min_partecipant",
      "max_partecipant",
      "min_completition_perc",
    ],
  },
  DA_VIRTUAL_CLASS: {
    sections: [
      "basic",
      "content",
      "cover",
      "standalone",
      "publication",
      "limits",
      "agenda",
    ],
    contentVariant: "class",

    durationRequired: true,

    requiredFields: [
      ...COMMON_REQUIRED,
      "min_partecipant",
      "max_partecipant",
      "min_completition_perc",
    ],
  },
};
